import React from 'react';
import styled from 'styled-components';

import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import RewardsMenuSection from 'components/rewards/RewardsMenuSection';

import type { MenuItemType } from 'components/layout/header/headerTypes';

const DownIconStyled = styled(MaterialSymbol)`
  /** Reduce right gap */
  margin-right: -6px;
  color: var(--gray4b);
`;

const rewardsMenuItem: MenuItemType = {
  type: 'MenuDropdownWithContentBox' as const,
  label: (
    <>
      Rewards <DownIconStyled icon="arrow_drop_down" rounded />
    </>
  ),
  content: () => <RewardsMenuSection />,
};

export default rewardsMenuItem;
